import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  commonEnum,
  CustomModalService,
  DistanceTypeEnum,
  orgPrefsReminder,
  reviewPrefsTxt,
} from '@piqet-angular/shared';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { Observable, Subject, catchError, finalize, forkJoin, of } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { AdministratorService } from '../administrator/administrator.service';
import { ToastrService } from 'ngx-toastr';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Router } from '@angular/router';
import { customDecode } from 'libs/shared/src/lib/service/helper.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  modal = inject(CustomModalService);
  administratorService = inject(AdministratorService);
  toaster = inject(ToastrService);
  swalService = inject(SwalService);
  router = inject(Router);

  public sideBarData = new BehaviorSubject<Function>(() => {});
  public sideBarData$ = this.sideBarData.asObservable();

  public reportData = new BehaviorSubject<any>({});
  public reportData$ = this.reportData.asObservable();

  public organizationMapData = new Subject<any>();
  public organizationMapData$ = this.organizationMapData.asObservable();

  public menuData = new BehaviorSubject<any>([]);
  public menuData$ = this.menuData.asObservable();

  public productProjectMenuArr = new BehaviorSubject<any>([]);
  public productProjectMenuArrData$ = this.productProjectMenuArr.asObservable();

  public productMenu = new BehaviorSubject<any>('');
  public productMenuData$ = this.productMenu.asObservable();

  public ingredientTransport = new BehaviorSubject<any>([]);
  public ingredientTransport$ = this.ingredientTransport.asObservable();

  public navSidebarData = new BehaviorSubject<any>([]);
  public navSidebarDataObs$ = this.navSidebarData.asObservable();

  public productSidebar = new BehaviorSubject<any>([]);
  public productSidebarObs$ = this.productSidebar.asObservable();

  public scenarioName = new BehaviorSubject<any>('');
  public scenarioNameObs$ = this.scenarioName.asObservable();

  public productName = new BehaviorSubject<any>('');
  public productNameObs$ = this.productName.asObservable();

  public startTour = new BehaviorSubject<any>(false);
  public startTourObs$ = this.startTour.asObservable();

  private scrollTrigger = new Subject<void>();
  scrollTriggered$ = this.scrollTrigger.asObservable();

  private disableAddRowBtn = new Subject<void>();
  disableAddRowBtnTrigger$ = this.disableAddRowBtn.asObservable();

  private showCalcErr = new Subject<any>();
  showCalcErrObs$ = this.showCalcErr.asObservable();

  private exportPreviewPDF = new Subject<any>();
  exportPreviewPDFObs$ = this.exportPreviewPDF.asObservable();

  apiUrl = environment.url;

  private removeBeaconScriptSubject = new Subject<void>();
  removeBeaconScript$ = this.removeBeaconScriptSubject.asObservable();

  editPallet = new Subject<[any, any]>();
  editPalletData$ = this.editPallet.asObservable();

  private spinnerMessage = new BehaviorSubject<string>('');
  spinnerMessage$ = this.spinnerMessage.asObservable();

  private supplierAddEdit = new Subject<any>();
  supplierAddEditObs$ = this.supplierAddEdit.asObservable();

  private deleteSupplierName = new Subject<any>();
  deleteSupplierNameObs$ = this.deleteSupplierName.asObservable();
  private scrollToBottomSource = new Subject<void>();
  scrollToBottom$ = this.scrollToBottomSource.asObservable();

  public mergeOrgsList = new Subject<boolean>();
  public mergeOrgsListObs$ = this.mergeOrgsList.asObservable();

  public updateUserDetails = new Subject<any>();
  public updateUserDetailsObs$ = this.updateUserDetails.asObservable();

  public productSidebarAccess = new Subject<any>();
  public productSidebarData$ = this.productSidebarAccess.asObservable();

  constructor(private http: HttpClient) {}

  triggerScrollToBottom(): void {
    this.scrollToBottomSource.next();
  }

  triggerRemoveBeaconScript() {
    this.removeBeaconScriptSubject.next();
  }

  passOrgMapData(data: any) {
    this.organizationMapData.next(data);
  }

  getCountry(defaultFlag = false) {
    return this.http.get<any>(
      `${this.apiUrl}/Country/GetAllCountryList?excludeCurrency=${defaultFlag}`
    );
  }

  getStates(payload: any) {
    return this.http
      .get<any>(`${this.apiUrl}/State/getStateByCountryId?countryId=${payload}`)
      .toPromise();
  }

  getPlan(payload: any) {
    return this.http.get<any>(`${this.apiUrl}/User/GetPlanList?currencyCode=${payload}`);
  }

  isEmailExist(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/isEmailExist`, payload);
  }

  getAllCity() {
    return this.http.get<any>(`${this.apiUrl}/City/GetAllCity`);
    // return this.http.get<any>('assets/json/AllCity.json').pipe(
    //   catchError((error: any) => {
    //     return this.fetchCityFromAPI();
    //   })
    // );
  }

  getAllFilterCity(pageNo: any, searchValue: any, isPort: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/City/GetAllCities?pageNo=${pageNo}&searchValue=${searchValue}&isPort=${isPort}`
      )
      .toPromise();
  }

  getCityIdByName(pageNo: any, searchValue: any, pageSize: any, isPort: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/City/GetCityIdByName?pageNo=${pageNo}&searchValue=${searchValue}&pageSize=${pageSize}&isPort=${isPort}`
      )
      .toPromise();
  }

  getAllCityForCustomOriginAutoComplete(term: string, isShowOnlyPort: boolean) {
    const encodedTerm = encodeURIComponent(term ?? '');
    return this.http
      .get<any>(
        `${this.apiUrl}/City/GetAllCityForCustomOriginAutoComplete?term=${encodedTerm}&isShowOnlyPort=${isShowOnlyPort}`
      )
      .toPromise();
  }

  resolveLocationsBulk(locations: string[]) {
    return this.http
      .post<any>(`${this.apiUrl}/City/ResolveLocationsBulk`, locations ?? [])
      .toPromise();
  }

  fetchCityFromAPI() {
    return this.http.get<any>(`${this.apiUrl}/City/GetAllCity`).pipe(
      catchError(error => {
        console.error('Error fetching data from API:', error);
        return of([]);
      })
    );
  }
  getTransactionList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Transactions/GetTransactionList`, payload);
  }

  getDistanceAndTime(
    latFrom: number,
    lngFrom: number,
    latTo: number,
    lngTo: number,
    originId: any,
    destinationId: any,
    mode: any
  ) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Project/CalculateSeaDistance?Lat_From=${latFrom}&Lang_From=${lngFrom}&Lat_To=${latTo}&Lang_To=${lngTo}&OriginId=${originId}&DestinationId=${destinationId}&Mode=${mode}`
      )
      .toPromise();
  }
  getAllGridConfigs() {
    return this.http.get<any>(`${this.apiUrl}/UserGridConfiguration/GetAllUserGridConfigurations`);
  }
  async checkValidationForProductSector(projectId: any) {
    return await this.http
      .get<any>(`${this.apiUrl}/Report/CheckValidationForProductSector?projectId=${projectId}`)
      .toPromise();
  }

  updateColumnConfigs(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/UserGridConfiguration/UpdateGridColumnOrder`,
      payload
    );
  }

  public accessSideBarData(data: any) {
    // To refresh packaging projects sidebar
    this.sideBarData.next(data);
  }

  accessProductSideBarData(data: any) { 
    this.productSidebarAccess.next(data);
  }

  reportDataFunction(data: object) {
    this.reportData.next(data);
  }

  public accessSideMenuArray(data: any) {
    this.menuData.next(data);
  }

  public getLatestIngredientTrasnport(data: any) {
    this.ingredientTransport.next(data);
  }

  public navigateSiderbarMenu(data: any) {
    this.navSidebarData.next(data);
  }

  public scenarioNameFunc(data: any) {
    this.scenarioName.next(data);
  }

  public accessProductSideMenuData(data: any) {
    // FOR PRODUCT Projects sidebar menu
    this.productMenu.next(data);
  }

  public accessProductSideMenuArray(data: any) {
    this.productProjectMenuArr.next(data);
  }

  public startTourFun(showTour: boolean, isTourDone?: any) {
    this.startTour.next([showTour, isTourDone]);
  }

  public triggerScroll(): void {
    this.scrollTrigger.next();
  }

  public updateProductName(data: any) {
    this.productName.next(data);
  }

  public disableAddRow(data: any) {
    this.disableAddRowBtn.next(data);
  }

  public showEOLTotalErr(data: any, type?: any) {
    this.showCalcErr.next([data, type]);
  }

  public triggerPDFExport() {
    this.exportPreviewPDF.next(true);
  }

  public openPalletViewModal(data: any) {
    this.editPallet.next(data);
  }

  show(message: string = '') {
    this.spinnerMessage.next(message);
  }

  public updatedSupplierName(data: any) {
    this.supplierAddEdit.next(data);
  }

  public deleteSupplier(data: any) {
    this.deleteSupplierName.next(data);
  }

  updateGuideTourStatus(type: any, isTourCompleted: any, lastStep?: any) {
    return this.http.post<any>(
      `${this.apiUrl}/User/UpdateGuideTourStatus?type=${type}&isTourCompleted=${isTourCompleted}&lastStep=${lastStep}`,
      {}
    );
  }

  getGuideTourStatus(type: any) {
    return this.http.get<any>(`${this.apiUrl}/User/GetGuideTourStatus?type=${type}`);
  }

  addBugReport(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/BugReport/AddUpdateBugReportDetail`, payload);
  }
  changeBugReportStatusDetail(statusId: any, bugReportId: any, categoryName: string) {
    return this.http.get<any>(
      `${this.apiUrl}/BugReport/ChangeBugReportStatusDetail?statusId=${statusId}&bugReportId=${bugReportId}&categoryName=${categoryName}`
    );
  }
  changeVerificationStatusDetail(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/UpdateOrganizationTermsDocumentStatus`,
      payload
    );
  }
  getReportList() {
    return this.http.get<any>(`${this.apiUrl}/BugReport/GetAllBugReportDetailList`).toPromise();
  }

  toggleMergeOrgList(isEnabled: boolean) {
    this.mergeOrgsList.next(isEnabled);
  }

  openEditOrgModal(data: any, title: any, fromEdit: any) {
    this.modal.invoke('newAdminOrganization', {
      initialState: {
        newAdminOrganizationData: data,
        label: title,
        fromEdit: fromEdit,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewAdminOrganizationEvent?.subscribe((saveAdminOrgData: any) => {
      this.editOrgDetails(saveAdminOrgData);
    });
  }

  editOrgDetails(data: any) {
    this.administratorService
      .addEditAdminOrganization(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.updateUserDetails.next('');
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  showPreferencesPopup() {
    this.swalService.confirm(orgPrefsReminder, reviewPrefsTxt, '', true).then(confirmed => {
      if (confirmed) this.router.navigate(['my-organization/organizationPreferences']);
    });
  }
  decodeURIComponentParam(params: any): string {
    return decodeURIComponent(params);
  }
  encodeURIComponentParam(params: any): string {
    return encodeURIComponent(params);
  }

  decodeString(encryptedString: any) {
    return window.atob(encryptedString);
  }
  encodeString(encryptedString: any) {
    return window.btoa(encryptedString);
  }

  loadGTScript() {
    const scriptTag = document.createElement('script');
    scriptTag.id = 'gtm-script';
    scriptTag.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-N49NR94N');
    `;
    document.head.appendChild(scriptTag);

    const noScriptTag = document.createElement('noscript');
    noScriptTag.id = 'gtm-noscript';
    noScriptTag.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N49NR94N"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noScriptTag);
  }

  removeGTScript() {
    const scriptTag = document.getElementById('gtm-script');
    if (scriptTag) document.head.removeChild(scriptTag);

    const noScriptTag = document.getElementById('gtm-noscript');
    if (noScriptTag) document.body.removeChild(noScriptTag);
  }

  removeSuccessEmailFromSession() {
    if (sessionStorage.getItem('registerEmail')) {
      sessionStorage.removeItem('registerEmail');
    }
  }

  getDistanceTypeByTransportMode(transportModeId: number): DistanceTypeEnum {
    switch (transportModeId) {
      case commonEnum.AIR_INTERNATIONAL:
        return DistanceTypeEnum.AirInternational;
      case commonEnum.AIR_DOMESTIC:
        return DistanceTypeEnum.AirDomestic;
      case commonEnum.SHIP_INTERNATIONAL:
        return DistanceTypeEnum.ShipInternational;
      default:
        throw new Error('Unsupported transport mode');
    }
  }

  isShipOrAirTransport(transportModeId: number): boolean {
    return (
      transportModeId === commonEnum.SHIP_INTERNATIONAL ||
      transportModeId === commonEnum.AIR_INTERNATIONAL ||
      transportModeId === commonEnum.AIR_DOMESTIC
    );
  }

  geocodeAddresses(addresses: string[]): Promise<Array<{ latitude: number; longitude: number }>> {
    const geocoder = new google.maps.Geocoder();
    const requests = addresses.map(
      address =>
        new Observable<{ latitude: number; longitude: number }>((observer: any) => {
          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results?.length) {
              const location = results[0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode failed for ${address}: ${status}`);
            }
          });
        })
    );
    return forkJoin(requests).toPromise() as Promise<
      Array<{ latitude: number; longitude: number }>
    >;
  }

  async getSeaOrAirDistanceKm(
    origin: string,
    destination: string,
    originId: any,
    destinationId: any,
    transportModeId: number
  ): Promise<string> {
    const [from, to] = await this.geocodeAddresses([origin, destination]);
    let distanceType: DistanceTypeEnum;
    try {
      distanceType = this.getDistanceTypeByTransportMode(transportModeId);
    } catch {
      distanceType = DistanceTypeEnum.ShipInternational;
    }
    const res = await this.getDistanceAndTime(
      from.latitude,
      from.longitude,
      to.latitude,
      to.longitude,
      originId,
      destinationId,
      distanceType
    );
    return res?.data != null ? String(res.data) : '0';
  }

  getGoogleDrivingDistanceKm(origin: string, destination: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      try {
        const service = new google.maps.DistanceMatrixService();
        const request: google.maps.DistanceMatrixRequest = {
          origins: [origin],
          destinations: [destination],
          travelMode: google.maps.TravelMode.DRIVING,
        };
        service.getDistanceMatrix(request, (response, status) => {
          if (status === google.maps.DistanceMatrixStatus.OK && response?.rows?.length) {
            const meters = response.rows[0].elements[0]?.distance?.value;
            resolve(meters != null ? (meters / 1000).toFixed(2) : '0');
          } else {
            resolve('0');
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  getGoogleDrivingDistanceText(origin: string, destination: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      try {
        const service = new google.maps.DistanceMatrixService();
        const request: google.maps.DistanceMatrixRequest = {
          origins: [origin],
          destinations: [destination],
          travelMode: google.maps.TravelMode.DRIVING,
        };
        service.getDistanceMatrix(request, (response, status) => {
          if (status === google.maps.DistanceMatrixStatus.OK && response?.rows?.length) {
            resolve(response.rows[0].elements[0]?.distance?.text ?? '0 km');
          } else {
            resolve('0 km');
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  getDistanceByTransportMode(
    origin: string,
    destination: string,
    originId: any,
    destinationId: any,
    transportModeId: number
  ): Promise<string> {
    return this.isShipOrAirTransport(transportModeId)
      ? this.getSeaOrAirDistanceKm(origin, destination, originId, destinationId, transportModeId)
      : this.getGoogleDrivingDistanceKm(origin, destination);
  }
  changeOrganizationVerificationStatus(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/VerifyTrialOrganization`, payload);
  }
}
